import "./Reviews01.css";

import user01 from "./../../../img/other/user-1.png";
import user02 from "./../../../img/other/user-2.png";
import user03 from "./../../../img/other/user-3.png";
import user04 from "./../../../img/other/user-4.png";

import stars from "./../../../img/icons/stars.png";

function Reviews01() {
  return (
    <div className="Reviews01 section" id="Reviews01">
      <div className="container">
        <div className="intro">
          <p className="eyebrow">TESTIMONIALS</p>
          <h2>See What Our Clients Say</h2>
          <p>
            Their stories reflect our commitment quality and service, showcasing
            how we strive to exceed expectations.
          </p>
        </div>

        <div className="Reviews01-box">
          <div className="Reviews01-list">
            <div className="Reviews01-list-slider">
              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user01} alt="" className="user" />

                  <div>
                    <h4>LEO MANOJ </h4>
                    <img src={stars} alt="" className="stars" />
                  </div>
                </div>

                <p>
                  "This was my first experience with Nazz, and it was absolutely
                  wonderful! He treated me like a brother and made sure my
                  haircut came out exactly the way I wanted..."
                </p>
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user02} alt="" className="user" />

                  <div>
                    <h4>Shaun Sany</h4>
                    <img src={stars} alt="" className="stars" />
                  </div>
                </div>

                <p>
                  "This is my second time coming to Razor King and I was not
                  disappointed... Also a little side note: They have great music
                  taste (my opinion). Will def be coming back, highly
                  recommend."
                </p>
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user03} alt="" className="user" />

                  <div>
                    <h4>Kevin Zhou</h4>
                    <img src={stars} alt="" className="stars" />
                  </div>
                </div>

                <p>
                  "I had a great experience here! Nazz gave me an excellent
                  haircut. He pays close attention to detail and ensures you
                  leave looking sharp..."
                </p>
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user04} alt="" className="user" />

                  <div>
                    <h4>Hayden Jordan</h4>
                    <img src={stars} alt="" className="stars" />
                  </div>
                </div>

                <p>
                  "I've been to Razor King a few times now, but this time was my
                  first with Nazz. He was super friendly and hooked me up with
                  one of the best cuts I've ever had..."
                </p>
              </div>
            </div>

            <div className="Reviews01-list-slider">
              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user01} alt="" className="user" />

                  <div>
                    <h4>LEO MANOJ </h4>
                    <img src={stars} alt="" className="stars" />
                  </div>
                </div>

                <p>
                  "This was my first experience with Nazz, and it was absolutely
                  wonderful! He treated me like a brother and made sure my
                  haircut came out exactly the way I wanted..."
                </p>
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user02} alt="" className="user" />

                  <div>
                    <h4>Shaun Sany</h4>
                    <img src={stars} alt="" className="stars" />
                  </div>
                </div>

                <p>
                  "This is my second time coming to Razor King and I was not
                  disappointed... Also a little side note: They have great music
                  taste (my opinion). Will def be coming back, highly
                  recommend."
                </p>
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user03} alt="" className="user" />

                  <div>
                    <h4>Kevin Zhou</h4>
                    <img src={stars} alt="" className="stars" />
                  </div>
                </div>

                <p>
                  "I had a great experience here! Nazz gave me an excellent
                  haircut. He pays close attention to detail and ensures you
                  leave looking sharp..."
                </p>
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user04} alt="" className="user" />

                  <div>
                    <h4>Hayden Jordan</h4>
                    <img src={stars} alt="" className="stars" />
                  </div>
                </div>

                <p>
                  "I've been to Razor King a few times now, but this time was my
                  first with Nazz. He was super friendly and hooked me up with
                  one of the best cuts I've ever had..."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reviews01;
